module.exports = __webpack_public_path__ + "media/images/features/refund/icon-step-01-88085fb415090939804092adc406f2b4.svg";